module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25221448"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/components/Footer.vue
// module id = 896
// module chunks = 0